/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable import/no-cycle */
import api from '@src/api';

// OTP 發送驗證碼
export const postOtpSendCodeCall = ({ action, form }) => api.post(`otp/${action}`, form);

// OTP 驗證碼驗證
export const postOtpVerifyCall = ({ action, form }) => api.post(`otp/${action}/verify`, form);
